// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconHomePath = 'M.09 9.35 9.947.67l9.96 8.676-1.313 1.508-1.593-1.388V16a3 3 0 0 1-2.824 2.995l-.176.005H6a3 3 0 0 1-2.995-2.824L3.001 16V9.451l-1.59 1.4-1.32-1.502Zm9.864-6.021L15 7.725V16l-.007.117a1 1 0 0 1-.993.883h-3v-4H9v4H6l-.117-.007A1 1 0 0 1 5.001 16V7.69L9.954 3.33Z';
var IconHome = baseIcon('IconHome', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconHomePath
});
export default IconHome;
//# sourceMappingURL=index.js.map